<div class="app-body">
  <main class="main d-flex align-items-center">
    <div class="container" style="margin-top: 5%">
      <div class="text-center">
        <img src="assets/img/brand/sygnet.png" alt="LC+" style="margin: 30px auto; width: 320px" />
      </div>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div class="card-group">
            <div class="card">
              <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
                  <p class="text-danger">{{ message }}</p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-user"></i></span>
                    </div>
                    <input
                      type="text"
                      formControlName="email"
                      class="form-control"
                      placeholder="E-mail"
                      [ngClass]="getValidationClass('email')" />
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <button type="submit" class="btn btn-primary px-4" [disabled]="!form.valid">Recover</button>
                    </div>
                    <div class="col-6 text-right">
                      <a routerLink="/login" class="btn btn-link px-0">Back</a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
